import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'any'
})
export class WorkOrderService {

	stageFilter = 'all';
	projectFilter = [];
	customerFilter = [];
	systemFilter = [];
	areaFilter = [];
	labourTypeFilter = [];
	teamFilter = [];
	userFilter = [];
	labelFilter = [];

	constructor() { }

	stageColor(stage, selected = true, defaultColor = 'secondary') {
		if (!selected) return defaultColor;

		switch (stage) {
			case 'all': return 'primary';
			case 'active': return 'success';
			case 'to_be_scheduled': return 'secondary';
			case 'scheduled': return 'info';
			case 'completed': return 'success';
		}
		return 'secondary';
	}

	stageDescription(stage) {
		switch (stage) {
			case 'all': return 'All';
			case 'active': return 'Active';
			case 'to_be_scheduled': return 'To Be Scheduled';
			case 'scheduled': return 'Scheduled';
			case 'completed': return 'Completed';
		}
		return '';
	}

	resolveStageFilter(s = null) {
		if (!s) s = this.stageFilter;

		if (s === 'all') return null;
		return [s];
	}

	stageList() {
		return ['all', 'to_be_scheduled', 'scheduled', 'active', 'completed'];
	}

	clearFilters() {
		this.areaFilter = [];
		this.systemFilter = [];
		this.labourTypeFilter = [];
		this.teamFilter = [];
		this.userFilter = [];
		this.projectFilter = [];
		this.customerFilter = [];
		this.labelFilter = [];
	}

}
